import { defineComponent as _defineComponent } from 'vue'
import { computed, useSlots, type InputHTMLAttributes } from 'vue';
import vSelect, { VueSelectData, VueSelectProps } from 'vue-select';
import CButton from '../CButton';
import type { CSelectItem, Primitive } from '.';


export default /*#__PURE__*/_defineComponent({
  __name: 'CSelect',
  props: {
    value: null,
    options: null,
    id: null,
    label: null,
    labelClass: null,
    modelTransform: null,
    alwaysOpen: { type: Boolean },
    disabled: { type: Boolean },
    placeholder: null,
    loading: null,
    searchable: { type: Boolean },
    filterable: { type: Boolean },
    clearable: { type: Boolean },
    appendToBody: { type: Boolean },
    groupValues: null,
    groupLabel: null,
    inline: { type: Boolean }
  },
  emits: ["input", "open", "close", "search", "delete-option"],
  setup(__props: any, { emit }: { emit: ({
    (event: 'input', value?: CSelectItem<Primitive> | Primitive): void;
    (event: 'open'): void;
    (event: 'close'): void;
    (event: 'search', val: string): void;
    (event: 'delete-option', value: CSelectItem<Primitive>): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
    value?: CSelectItem<Primitive> | Primitive;
    options: CSelectItem<Primitive>[];
    id?: InputHTMLAttributes['id'];
    label?: string;
    labelClass?: InputHTMLAttributes['class'];
    modelTransform?: VueSelectProps['reduce'];
    alwaysOpen?: boolean;
    disabled?: boolean;
    placeholder?: VueSelectProps['placeholder'];
    loading?: VueSelectProps['loading'];
    searchable?: boolean;
    filterable?: boolean;
    clearable?: boolean;
    appendToBody?: boolean;
    groupValues?: string;
    groupLabel?: string;
    inline?: boolean;
};





const model = computed({
    get: () => props.value,
    set: (value?: CSelectItem<Primitive> | Primitive) => emit('input', value)
});
const slots = useSlots();

const dropdownShouldOpen = ({ open, mutableLoading }: VueSelectData) => {
    return props.alwaysOpen || (open && !mutableLoading);
};

const isOptionSelectable: VueSelectProps['selectable'] = (item) => !(item as CSelectItem)?.disabled;

return { __sfc: true,props, emit, model, slots, dropdownShouldOpen, isOptionSelectable, vSelect, CButton }
}

})